import React, { useEffect, useState} from 'react';
import styles from './FavouriteStar.scss';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import _some from 'lodash/some';
import {saveFavourite, deleteFavourite, removePropertyFromCollection, collectionModalOpen} from '../../actions';
import RemoveCollection from '../Modal/CollectionModal/RemoveCollection';

const FavouriteStar = (props) => {

  const {
    propertyId,
    size,
    property,
    listingId,
    useNewIcon,
    hasLabel,
    isUserAuthenticated,
    userFavourites,
    saveFavourite,
    deleteFavourite,
    isFromCollection = false,
    removePropertyFromCollection,
    collectionModalOpen,
    collections
  } = props;

  const [isFavourite, setIsFavourite] = useState(false);
  const emptyStar = useNewIcon ? styles.starEmpty2 : styles.starEmpty;
  const fullStar = useNewIcon ? styles.starFull2 : styles.starFull;
  const [showRemoveCollectionModal, setShowRemoveCollectionModal] = useState(false);
  const favSize = size && size !== '' ? size : '';

  const toggleFavourite = (event) => {
    event.preventDefault();

    if(isFromCollection) {
      setShowRemoveCollectionModal(true);
    } else {
      if (!isFavourite) {
        saveFavourite({
          propertyId: propertyId,
          property: property,
          listingId: listingId
        });
      }
      else {
        if(collections.list.length > 0) {
          collectionModalOpen({ othPropertyId: propertyId || property.othPropertyId});
        } else {
          deleteFavourite({propertyId: propertyId});
        }
      }
    }

  };

  const checkIfUserFavourite = () => {
    setIsFavourite(_some(userFavourites.favourites, {propertyId: propertyId || property.othPropertyId}));
  };



  const handleRemoveFromCollection = () => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const uuid = params.get('id');

    removePropertyFromCollection({
      collectionUuid: uuid,
      othPropertyId: propertyId || property.othPropertyId
    });
  };

  const handleRemoveFromAllProperties = () => {
    deleteFavourite({propertyId: propertyId || property.othPropertyId});
    handleRemoveFromCollection();
    setShowRemoveCollectionModal(false);
  };

  useEffect(() => {
    if(isUserAuthenticated) {
      checkIfUserFavourite();
    }
  }, [isUserAuthenticated, userFavourites]);


  return (
    <>
      <span onClick={toggleFavourite}>
        {hasLabel && <span className="mr-3 d-flex align-self-center">{isFavourite ? 'Saved' : 'Save'}</span>}
        <span className={styles.favouriteStar + ' ' + (favSize !== '' ? (styles['favouriteStar' + favSize] + ' ') : '') + (isFavourite ? fullStar : emptyStar)}></span>
      </span>

      <RemoveCollection
        showModal={showRemoveCollectionModal}
        toggleModal={() => setShowRemoveCollectionModal(false)}
        onRemoveFromCollection={() => {
          handleRemoveFromCollection();
          setShowRemoveCollectionModal(false);
        }}
        onRemoveFromAllProperties={() => handleRemoveFromAllProperties()}
        isFromFavouriteStar={true}
      />

    </>
  );
};

FavouriteStar.propTypes = {
  propertyId: PropTypes.string.isRequired,
  size: PropTypes.string,
  property: PropTypes.object,
  listingId: PropTypes.string,
  useNewIcon: PropTypes.bool,
  hasLabel: PropTypes.bool,
  isUserAuthenticated: PropTypes.bool,
  userFavourites: PropTypes.object,
  saveFavourite: PropTypes.func,
  deleteFavourite: PropTypes.func,
  isFromCollection: PropTypes.bool,
  removePropertyFromCollection: PropTypes.func,
  collectionModalOpen: PropTypes.func,
  collections: PropTypes.object
};

const mapDispatchToProps = {
  saveFavourite,
  deleteFavourite,
  removePropertyFromCollection,
  collectionModalOpen
};

const mapStateToProps = (state) => ({
  isUserAuthenticated: state.user.authenticated,
  userFavourites: state.userFavourites,
  collections: state.collections
});

export default connect(mapStateToProps, mapDispatchToProps)(FavouriteStar);
